import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Card,
  CardBody,
  CardHeader
} from "shards-react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import "../../admin/userDetails/tab.css";
import UsersOverview from "../../../components/blog/UsersOverview";
import { useAuth } from "../../../providers/AuthProvider";
var moment = require("moment"); // require
const StudentCalibtrationOverView = () => {
  const { id } = useParams();
  const { currentUser } = useAuth();
  //const [studentIds, setStudentIds] = useState([]);
  const [calibrationData, setCalibrationData] = useState("");
  const [phoneH, setPhoneH] = useState(0);
  const [phoneW, setPhoneW] = useState(0);
  const [pixelRatio, setpixelRatio] = useState(0);
  const [deviceModel, setDeviceModel] = useState("-");
  useEffect(() => {
    checkStudentAssignedOrNot();
    getCalibrationData();
  }, []);

  // useEffect(() => {
  //   if (studentIds.length > 0) {
  //     if (studentIds.some(item => item.id == id)) {
  //       getCalibrationData();
  //     } else {
  //       history.goBack();
  //     }
  //   }
  // }, [studentIds])

  const checkStudentAssignedOrNot = async () => {
    const docRef = doc(db, "SubAdminData", currentUser.uid);
    await getDoc(docRef);
    // if (adminSnapData.exists()) {
    //  // setStudentIds(adminSnapData.data().AssignedUsers ? adminSnapData.data().AssignedUsers : [])
    // }
  };

  const getCalibrationData = async () => {
    const docRef = doc(db, "CalibrateResult", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setCalibrationData(docSnap.data());
      setPhoneH(
        docSnap.data().DeviceDimensions &&
          docSnap.data().DeviceDimensions.height
      );
      setPhoneW(
        docSnap.data().DeviceDimensions && docSnap.data().DeviceDimensions.width
      );
      setpixelRatio(
        docSnap.data().DeviceDimensions &&
          docSnap.data().DeviceDimensions.pixelRatio
      );
      if (docSnap.data().RecordedDevice) {
        const deviceData = await getDoc(docSnap.data().RecordedDevice);
        if (deviceData.exists()) {
          setDeviceModel(deviceData.data().model);
        }
      }
    } else {
      console.log("No such document!");
    }
  };
  return (
    <>
      {calibrationData !== "" ? (
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col lg="12" md="12" sm="12" className="mb-4">
              <Card small className="mb-4 pt-4">
                <CardHeader className="border-bottom">
                  <h4 className="mb-0">Calibration Details</h4>
                </CardHeader>
                <CardBody className="border-bottom ">
                  <ListGroup flush>
                    <ListGroupItem className="px-4">
                      <strong className="text-muted d-block mb-2">
                        Calibrated On Date :{" "}
                        {calibrationData.CalibratedOnDate &&
                          moment(
                            calibrationData.CalibratedOnDate.toDate().toString()
                          ).format("lll")}
                      </strong>
                    </ListGroupItem>
                    <ListGroupItem className="p-4">
                      <strong className="text-muted d-block mb-2">
                        Calibration Avg : {calibrationData.CalibrationAvg}
                      </strong>
                    </ListGroupItem>
                    <ListGroupItem className="p-4">
                      <strong className="text-muted d-block mb-2">
                        Offset Value : {calibrationData.OffsetValue}
                      </strong>
                    </ListGroupItem>
                    <ListGroupItem className="p-4">
                      <strong className="text-muted d-block mb-2">
                        Pendlum Length : {calibrationData.PendlumLength}
                      </strong>
                    </ListGroupItem>
                    <ListGroupItem className="p-4">
                      <strong className="text-muted d-block mb-2">
                        Phone Resolutions :{" "}
                        {phoneH * pixelRatio + " X " + phoneW * pixelRatio}
                      </strong>
                    </ListGroupItem>
                    <ListGroupItem className="p-4">
                      <strong className="text-muted d-block mb-2">
                        Device Model : {deviceModel}
                      </strong>
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="12" md="12" sm="12" className="mb-4">
              {calibrationData && (
                <UsersOverview data={calibrationData.CalibrationData} />
              )}
            </Col>
          </Row>
        </Container>
      ) : (
        <Container fluid className="main-content-container px-4">
          <div className="wrapper">
            <div className="spinner">
              <div className="spinner-1"></div>
              <div className="spinner-2"></div>
              <div className="spinner-3"></div>
            </div>
          </div>
          {/* <Row>
          <Col  style={{
                  height: "75vh",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex"
                }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row> */}
        </Container>
      )}
    </>
  );
};

export default StudentCalibtrationOverView;
